export const locale = {
  lang: 'en',
  data: {
    ERROR: {
      HTTP: {
        MAINTENANCE: {
          'TITLE': 'The system is under maintenance from {{fromTime}} on {{fromDate}} to {{toTime}} on {{toDate}}',
          'MESSAGE': 'The system is under maintenance to fix bugs and update new features to improve quality and user experience. We\'re sorry for the inconvenience!'
        }
      },
    },
  },
};
